import {
  AfterContentInit,
  Component,
  ContentChild,
  ContentChildren,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2
} from '@angular/core';
import {DragulaService} from 'ng2-dragula';
import {Subscription} from 'rxjs';
import {DragObject, TYPE_DRAGLIST} from '../../models/drag-list';

@Component({
  selector: 'cmp-dragula-list',
  template: `<div class='wrapper'>
  <ul [ngClass]="dragObject.dragListObject[dragKey].ulClass != null ? dragObject.dragListObject[dragKey].ulClass : ''" [dragula]='dragObject.dragBag' [dragulaModel]='dragObject.dragListObject[dragKey].values'>
    <ng-content></ng-content>
    <li *ngIf="!dragObject.dragListObject[dragKey] || !dragObject.dragListObject[dragKey].values || dragObject.dragListObject[dragKey].values.length === 0"
        [ngClass]="dragObject.dragListObject[dragKey].liClass != null ? dragObject.dragListObject[dragKey].liClass : ''" [innerHtml]='dragObject.dragListObject[dragKey].emptyMessage'></li>
  </ul>
</div>

`,
  styles: [``]
})
export class DragulaListComponent implements OnInit {
  @Input() dragKey: string;
  @Input() dragObject: DragObject
  @Output() reloadDragObject = new EventEmitter();

  constructor(private dragulaService: DragulaService) {
  }

  ngOnInit() {
    if (this.dragObject.dragListObject[this.dragKey].masterList) {
      this.dragulaService.setOptions(this.dragObject.dragListObject[this.dragKey].dragBag, {
        moves: function (el, container, handle) {
          if (el.className && el.className.length > 0) {
            return el.className.indexOf('handle-dragula') > -1;
          }
          return false;
        }
      });
      this.dragulaService.dropModel.subscribe((value) => {
        this.onDropModel();
      });
    }
  }

  private onDropModel() {
    const has = Object.prototype.hasOwnProperty;
    const interactionDrag = {
      less: null,
      more: null,
      equals: []
    };
    if (this.dragObject && this.dragObject.dragListObject) {
      for (const key in this.dragObject.dragListObject) {
        if (has.call(this.dragObject.dragListObject, key)) {
          const actualLength = this.dragObject.dragListObject[key].values.length;
          if (actualLength < this.dragObject.dragListObject[key].previousLength) {
            interactionDrag.less = key;
          } else if (actualLength > this.dragObject.dragListObject[key].previousLength) {
            interactionDrag.more = key;
          } else {
            interactionDrag.equals.push(key);
          }
          this.dragObject.dragListObject[key].previousLength = this.dragObject.dragListObject[key].values.length;
        }
      }
    }
    this.setBehaviourDragula(interactionDrag);
  }

  setBehaviourDragula(interactionDrag) {
    this.reloadDragObject.emit({dragObject: this.dragObject, interactionDrag});
  }
}
